// src/components/Cta.tsx
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Section = styled.section`
    padding: 80px 0;
`;

const CtaSection = styled(Section)`
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    text-align: center;
    color: white;
`;

const CtaContent = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 0 2rem;
`;

const CtaTitle = styled(motion.h2)`
    font-size: 3.5rem;
    font-weight: 800;
    margin-bottom: 1.5rem;
    line-height: 1.1;

    @media (max-width: 768px) {
        font-size: 2.5rem;
    }
`;

const CtaSubtitle = styled(motion.p)`
    font-size: 1.25rem;
    margin-bottom: 3rem;
    opacity: 0.9;
    line-height: 1.6;
`;

const CtaButton = styled(motion.button)`
    background: white;
    color: #667eea;
    border: none;
    padding: 1.25rem 3rem;
    border-radius: 10px;
    font-size: 1.125rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 8px 25px rgba(255, 255, 255, 0.2);

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 35px rgba(255, 255, 255, 0.3);
    }
`;

interface CtaProps {
    onNavigateToTrips: () => void;
}

const Cta: React.FC<CtaProps> = ({ onNavigateToTrips }) => {
    return (
        <CtaSection>
            <CtaContent>
                <CtaTitle
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    Ready for Your Adventure?
                </CtaTitle>
                <CtaSubtitle
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    viewport={{ once: true }}
                >
                    Join thousands of travelers who have discovered the magic of Central Europe with our tours
                </CtaSubtitle>
                <CtaButton
                    onClick={onNavigateToTrips}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    viewport={{ once: true }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Start Your Journey
                </CtaButton>
            </CtaContent>
        </CtaSection>
    );
};

export default Cta;